import DialogFormPanel from "../../../../shared/components/panel/DialogFormPanel";
import CreateButtonTrigger from "../../../../shared/components/button/CreateButtonTrigger";
import CreateUserForm from "./CreateUserForm";
import { useState } from "react";

const CreateUserDialog = ({ onSubmitHandler, roles }) => {
  const [isOpen, setIsOpen] = useState(false);

  const onSubmit = (formValues) => {
    onSubmitHandler(formValues);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title="Alta nuevo usuario"
      description="Crear un nuevo usuario y comunicar por email la creación"
      content={<CreateUserForm onSubmitHandler={onSubmit} roles={roles} />}
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateUserDialog;
